export enum EnrollmentStatus {
    Open = 'Open',
    Satisfied = 'Satisfied',
    Cancelled = 'Cancelled',
}
